import styled from "styled-components";
import instructions from '../media/pdf/EPDMTrading_Instructions_bg.pdf';
import techInfo from '../media/pdf/EPDMTrading_Technical_Info.pdf';
import cardMembrane from '../media/pdf/EPDMTrading_Card_Membrane.pdf';
import cardCornerFlashing from '../media/pdf/EPDMTrading_Card_Corner_Flashing.pdf';
import cardFlashing from '../media/pdf/EPDMTrading_Card_Flashing_Tape.pdf';
import cardSeam from '../media/pdf/EPDMTrading_Card_Seam_Tape.pdf';
import {QRCodeCanvas} from 'qrcode.react';

const Wrapper = styled.object`

`;

const StyledPdf = styled.object`
    width: 100%;
    height: 900px;
`;

export default function PdfSources({document}) {
    if (document === "instructions") {
        return (
            <Wrapper>
                <StyledPdf data={instructions} type="application/pdf"/>
                <QRCodeCanvas value="https://epdm.bg/pdf/instructions"/>
            </Wrapper>
        );
    } else if (document === "techInfo") {
        return (
            <StyledPdf data={techInfo} type="application/pdf"/>
        );
    } else if (document === "cardMembrane") {
        return (
            <StyledPdf data={cardMembrane} type="application/pdf"/>
        );
    } else if (document === "cardCornerFlashing") {
        return (
            <StyledPdf data={cardCornerFlashing} type="application/pdf"/>
        );
    } else if (document === "cardFlashing") {
        return (
            <StyledPdf data={cardFlashing} type="application/pdf"/>
        );
    } else if (document === "cardSeam") {
        return (
            <StyledPdf data={cardSeam} type="application/pdf"/>
        );
    }
}

